import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

Sentry.init({
  dsn: 'https://f8b93e2314a7682db8d4365fbb600f85@o4510158466252800.ingest.us.sentry.io/4510158467694592',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  // Only enable Sentry in production
  enabled: window.location.hostname === 'secure.ffd.ai',
});

// eslint-disable-next-line unicorn/prefer-top-level-await
bootstrapApplication(AppComponent, appConfig).catch((error) => console.error(error));
